import { state } from 'cerebral'
import { isNil } from 'ramda'

export const geofencesForMap = (get) => {
  const shownOnMap = get(state`geofenceRegions.shownOnMap`) || {}
  const geofenceRegions = get(state`geofenceRegions.list.data`)
  return geofenceRegions.filter(({ _id }) => shownOnMap[_id])
}

export const boundsForMap = (get) => {
  const geofenceRegions = get(state`geofenceRegions.geofencesForMap`)
  const shownOnMap = get(state`geofenceRegions.shownOnMap`) || {}
  const organization = get(state`account.organization`) || {}

  let regions = geofenceRegions.map(({ _id, feature, radius }) => {
    const { geometry: { coordinates: [longitude, latitude] = [] } = {} } = feature
    return { id: _id, latitude, longitude, radius }
  })

  if (shownOnMap[organization.slug]) {
    const resortGeofence = { id: organization.slug, latitude: organization.latitude, longitude: organization.longitude, radius: organization.regionRadiusMiles }
    regions.push(resortGeofence)
  }

  const bounds = regions.reduce((result, current) => {
    const { latitude, longitude, radius } = current
    if (!isNil(latitude) && !isNil(longitude)) {
      const milesToLatDeg = radius ? radius / 69 : 0 // 1° lat ≈ 69 miles
      const milesToLngDeg = radius ? radius / (69 * Math.cos((latitude * Math.PI) / 180)) : 0

      const minLat = latitude - milesToLatDeg
      const maxLat = latitude + milesToLatDeg
      const minLng = longitude - milesToLngDeg
      const maxLng = longitude + milesToLngDeg

      if (result.length === 0) {
        return [
          [minLng, minLat],
          [maxLng, maxLat],
        ]
      } else {
        const [[curMinLng, curMinLat], [curMaxLng, curMaxLat]] = result
        return [
          [Math.min(curMinLng, minLng), Math.min(curMinLat, minLat)],
          [Math.max(curMaxLng, maxLng), Math.max(curMaxLat, maxLat)],
        ]
      }
    }

    return result
  }, [])

  return bounds
}
